// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hire tab: layout and styles come from ../Interview/interview.css (sections)
   and ../Candidates/Candidates.css (candidate list, evaluation, toast).
   Nothing Hire-specific is needed any more; this file is kept so the import
   stays valid. */
`, "",{"version":3,"sources":["webpack://./src/views/industry/advertisements/Hire/Hire.css"],"names":[],"mappings":"AAAA;;;iBAGiB","sourcesContent":["/* Hire tab: layout and styles come from ../Interview/interview.css (sections)\n   and ../Candidates/Candidates.css (candidate list, evaluation, toast).\n   Nothing Hire-specific is needed any more; this file is kept so the import\n   stays valid. */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
